import { useEventBus, type EventBusKey } from '@vueuse/core';

const cookiePreferencesKey: EventBusKey<void> = Symbol('cookie-preferences');

export const useCookiePreferencesBus = () => useEventBus(cookiePreferencesKey);
